import React from 'react';
import { Breadcrumb, Col, Row } from 'react-bootstrap';
import {
    FiCheckCircle,
    FiHeadphones,
    FiInfo,
    FiLogOut,
    FiMessageCircle,
    FiRefreshCw,
    FiSearch,
    FiTrendingUp,
    FiUserCheck,
    FiUsers,
    FiPlay,
} from 'react-icons/fi';
import './resumen.scss';

const EmbudoEtapas = [
    { Titulo: 'Sesiones iniciadas', Porcentaje: 100, Usuarios: 520, Ancho: 100, Icono: <FiMessageCircle /> },
    { Titulo: 'Usuarios validados', Porcentaje: 86, Usuarios: 447, Ancho: 88, Icono: <FiUserCheck /> },
    { Titulo: 'Consultas realizadas', Porcentaje: 74, Usuarios: 385, Ancho: 76, Icono: <FiSearch /> },
    { Titulo: 'Derivados al desarrollador', Porcentaje: 22, Usuarios: 114, Ancho: 60, Icono: <FiHeadphones /> },
    { Titulo: 'Sesiones finalizadas', Porcentaje: 68, Usuarios: 354, Ancho: 48, Icono: <FiCheckCircle /> },
];

const ErroresValidacion = [
    { Titulo: 'DNI/RUC no encontrado', Valor: 20, Color: '#0a7d33' },
    { Titulo: 'Numero no coincide', Valor: 12, Color: '#2fa14e' },
    { Titulo: 'Usuario no autorizado', Valor: 7, Color: '#7cc98a' },
    { Titulo: 'Formato invalido', Valor: 3, Color: '#cdeccb' },
];

const ConsultasCategoria = [
    { Titulo: 'Cuota del mes', Valor: 24, Color: '#056b2e' },
    { Titulo: 'Avance de cuota', Valor: 31, Color: '#0ea53a' },
    { Titulo: 'Puntos y premios', Valor: 15, Color: '#67c86d' },
    { Titulo: 'Comunicaciones', Valor: 10, Color: '#8fdb90' },
    { Titulo: 'Malla promocional', Valor: 8, Color: '#b0e7ad' },
    { Titulo: 'Promocion Sell Out', Valor: 5, Color: '#ccefc6' },
    { Titulo: 'Quiero comprar', Valor: 4, Color: '#def5d8' },
    { Titulo: 'Hablar con desarrollador', Valor: 3, Color: '#edf9ea' },
];

const SesionesIncompletas = [
    { Titulo: 'Sesiones iniciadas', Valor: 520, Porcentaje: 100, Icono: <FiPlay /> },
    { Titulo: 'Abandonos',          Valor: 96,  Porcentaje: 18,  Icono: <FiLogOut /> },
    { Titulo: 'Reintentos',         Valor: 31,  Porcentaje: 6,   Icono: <FiRefreshCw /> },
    { Titulo: 'Finalizadas',        Valor: 354, Porcentaje: 68,  Icono: <FiCheckCircle /> },
];

function ObtenerTotal(Lista) {
    return Lista.reduce((Acumulado, Item) => Acumulado + Item.Valor, 0);
}

function ObtenerMaximo(Lista) {
    return Math.max(...Lista.map((Item) => Item.Valor));
}

function ConstruirGradienteDonut(Lista) {
    const Total = ObtenerTotal(Lista);
    let Inicio = 0;

    const Secciones = Lista.map((Item) => {
        const Avance = (Item.Valor / Total) * 100;
        const Tramo = `${Item.Color} ${Inicio}% ${Inicio + Avance}%`;
        Inicio += Avance;
        return Tramo;
    });

    return `conic-gradient(${Secciones.join(', ')})`;
}

const Resumen = () => {
    const TotalErrores = ObtenerTotal(ErroresValidacion);
    const GradienteErrores = ConstruirGradienteDonut(ErroresValidacion);
    const GradienteConsultas = ConstruirGradienteDonut(ConsultasCategoria);
    const MaximoSesiones = ObtenerMaximo(SesionesIncompletas);

    return (
        <div className="resumen-container">
            <div className="breadcrumb-header">
                <Breadcrumb>
                    <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
                    <Breadcrumb.Item active>Resumen</Breadcrumb.Item>
                </Breadcrumb>
            </div>

            <div className="resumen-main-container">
                

                <Row className="g-4">
                    <Col xl={6}>
                        <section className="dashboard-card dashboard-card--blue dashboard-card--equal">
                            <div className="dashboard-card__header">
                                <div>
                                    <h2>Errores de validación</h2>
                                    <p>Indicador referencial del proceso de autenticación por DNI o RUC.</p>
                                </div>
                            </div>

                            <div className="donut-layout">
                                <div className="donut-visual">
                                    <div className="donut-chart donut-chart--blue" style={{ '--donut-fill': GradienteErrores }}>
                                        <div className="donut-chart__center">
                                            <strong>{TotalErrores}</strong>
                                            <span>errores totales</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="legend-list">
                                    {ErroresValidacion.map((ErrorItem) => (
                                        <div key={ErrorItem.Titulo} className="legend-item">
                                            <div className="legend-item__main">
                                                <span className="legend-dot" style={{ backgroundColor: ErrorItem.Color }}></span>
                                                <span>{ErrorItem.Titulo}</span>
                                            </div>
                                            <strong>{ErrorItem.Valor}</strong>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="dashboard-note dashboard-note--blue">
                                <FiInfo />
                                <span>Indicador referencial para demo</span>
                            </div>
                        </section>
                    </Col>

                    <Col xl={6}>
                        <section className="dashboard-card dashboard-card--equal">
                            <div className="dashboard-card__header">
                                <div>
                                    <h2>Consultas por categoría</h2>
                                    <p>Distribución estimada de los temas más consultados en el chatbot.</p>
                                </div>
                            </div>

                            <div className="donut-layout">
                                <div className="donut-visual">
                                    <div className="donut-chart" style={{ '--donut-fill': GradienteConsultas }}>
                                        <div className="donut-chart__center">
                                            <strong>100%</strong>
                                            <span>Total de consultas</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="legend-list">
                                    {ConsultasCategoria.map((Categoria) => (
                                        <div key={Categoria.Titulo} className="legend-item">
                                            <div className="legend-item__main">
                                                <span className="legend-dot" style={{ backgroundColor: Categoria.Color }}></span>
                                                <span>{Categoria.Titulo}</span>
                                            </div>
                                            <strong>{Categoria.Valor}%</strong>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </section>
                    </Col>
                </Row>

                <Row className="g-4">
                    <Col xl={6}>
                        <section className="dashboard-card dashboard-card--equal">
                            <div className="dashboard-card__header">
                                <div>
                                    <h2>Derivaciones al desarrollador</h2>
                                    <p>Resumen visual de usuarios que necesitaron asistencia humana.</p>
                                </div>
                            </div>

                            <div className="derivation-layout">
                                <div className="donut-chart donut-chart--half" style={{ '--donut-fill': 'conic-gradient(#148c34 0% 28%, #e4f6dd 28% 100%)' }}>
                                    <div className="donut-chart__center">
                                        <strong>28%</strong>
                                    </div>
                                </div>

                                <div className="derivation-side">
                                    <div className="legend-item">
                                        <div className="legend-item__main">
                                            <span className="legend-dot" style={{ backgroundColor: '#148c34' }}></span>
                                            <span>Si</span>
                                        </div>
                                        <strong>28%</strong>
                                    </div>
                                    <div className="legend-item">
                                        <div className="legend-item__main">
                                            <span className="legend-dot" style={{ backgroundColor: '#dff3d8' }}></span>
                                            <span>No</span>
                                        </div>
                                        <strong>72%</strong>
                                    </div>

                                    <div className="derivation-users">
                                        <div className="derivation-users__icon">
                                            <FiUsers />
                                        </div>
                                        <div>
                                            <span>Usuarios derivados:</span>
                                            <strong>114</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </Col>

                    <Col xl={6}>
                        <section className="dashboard-card dashboard-card--equal">
                            <div className="dashboard-card__header dashboard-card__header--spread">
                                <div>
                                    <h2>Sesiones incompletas</h2>
                                    <p>Resumen de sesiones del chatbot</p>
                                </div>
                                <div className="abandon-chip">
                                    <FiTrendingUp />
                                    <span>Tasa de abandono:</span>
                                    <strong>18%</strong>
                                </div>
                            </div>

                            <div className="sc-wrap">
                                {/* Leyenda */}
                                <div className="sc-legend">
                                    <span className="sc-legend__bar"><i></i>Cantidad de sesiones</span>
                                    <span className="sc-legend__line"><b></b>Porcentaje del total</span>
                                </div>

                                {/* Área del gráfico */}
                                <div className="sc-chart-area">
                                    {/* Eje Y izquierdo */}
                                    <div className="sc-axis sc-axis--left">
                                        {[600, 450, 300, 150, 0].map(v => (
                                            <span key={v}>{v}</span>
                                        ))}
                                    </div>

                                    {/* Columnas + línea SVG */}
                                    <div className="sc-columns-wrap">
                                        {/* Línea SVG superpuesta */}
                                        <svg className="sc-svg-line" viewBox="0 0 400 220" preserveAspectRatio="none">
                                            <polyline
                                                points={SesionesIncompletas.map((s, i) => {
                                                    const x = (i / (SesionesIncompletas.length - 1)) * 400;
                                                    const y = 220 - (s.Porcentaje / 100) * 200;
                                                    return `${x},${y}`;
                                                }).join(' ')}
                                                fill="none"
                                                stroke="#2d9c3c"
                                                strokeWidth="2.5"
                                            />
                                            {SesionesIncompletas.map((s, i) => {
                                                const x = (i / (SesionesIncompletas.length - 1)) * 400;
                                                const y = 220 - (s.Porcentaje / 100) * 200;
                                                return <circle key={i} cx={x} cy={y} r="7" fill="#8bd17f" stroke="#2b8e3d" strokeWidth="3" />;
                                            })}
                                        </svg>

                                        {/* Columnas */}
                                        {SesionesIncompletas.map((Sesion, idx) => (
                                            <div key={Sesion.Titulo} className="sc-col">
                                                <div className="sc-plot">
                                                    <span className="sc-val">{Sesion.Valor}</span>
                                                    <div
                                                        className="sc-bar"
                                                        style={{ height: `${(Sesion.Valor / MaximoSesiones) * 200}px` }}
                                                    />
                                                    {/* % junto al punto de línea */}
                                                    <span
                                                        className="sc-pct"
                                                        style={{ bottom: `${(Sesion.Porcentaje / 100) * 200 + 14}px` }}
                                                    >{Sesion.Porcentaje}%</span>
                                                </div>
                                                <div className="sc-label">
                                                    <span className="sc-label__icon">{Sesion.Icono}</span>
                                                    <span className="sc-label__text">{Sesion.Titulo}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Eje Y derecho */}
                                    <div className="sc-axis sc-axis--right">
                                        {[100, 75, 50, 25, 0].map(v => (
                                            <span key={v}>{v}%</span>
                                        ))}
                                    </div>
                                </div>

                                {/* Títulos de ejes */}
                                <div className="sc-axis-titles">
                                    <span>Sesiones</span>
                                    <span>Porcentaje</span>
                                </div>
                            </div>

                            <div className="sessions-summary">
                                <div className="sessions-summary__info">
                                    <FiInfo />
                                    <span>De <strong>520</strong> sesiones iniciadas, <strong>96</strong> fueron abandonadas antes de completarse.</span>
                                </div>
                                <strong>354 sesiones finalizadas (68%)</strong>
                            </div>
                        </section>
                    </Col>
                </Row>

                <section className="dashboard-card dashboard-card--funnel">
                    <div className="dashboard-card__header">
                        <div>
                            <h2>Embudo de uso del chatbot</h2>
                            <p>Seguimiento visual del recorrido principal del usuario dentro del flujo.</p>
                        </div>
                        <button type="button" className="dashboard-filter-button">
                            <FiTrendingUp />
                        </button>
                    </div>

                    <div className="funnel-board">
                        {EmbudoEtapas.map((Etapa) => (
                            <div key={Etapa.Titulo} className="funnel-row">
                                <div className="funnel-percent-ring">
                                    <span>{Etapa.Porcentaje}%</span>
                                </div>
                                <div className="funnel-track">
                                    <div
                                        className="funnel-shape"
                                        style={{ '--funnel-width': `${Etapa.Ancho}%` }}
                                    >
                                        <div className="funnel-icon">{Etapa.Icono}</div>
                                        <span>{Etapa.Titulo}</span>
                                    </div>
                                </div>
                                <div className="funnel-value">
                                    <strong>{Etapa.Usuarios}</strong>
                                    <span>usuarios</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Resumen;
